import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';

import {
  Heading,
  IFilterOption,
  FilterSelect
} from '@warrenbrasil/nebraska-web';
import {
  HeaderFilterLoader,
  HeaderSubtitleLoader
} from '@/modules/trade/views/TradePositionsView/components/Loaders';

import {
  DerivativesFiltersDateValues,
  DerivativesFiltersTypes,
  DerivativesFiltersTypeValues,
  IDerivativesFilters
} from '../../types';
import { StringFormatted } from '@/modules/trade/types';

interface Props {
  updatedAt?: string;
  isLoading?: boolean;
  filters: IDerivativesFilters;
}
type Emits = (
  event: 'on-filter-change',
  filterType: DerivativesFiltersTypes,
  filter?: DerivativesFiltersTypeValues | DerivativesFiltersDateValues
) => void;


export default /*#__PURE__*/_defineComponent({
  __name: 'DerivativesFilters',
  props: {
    updatedAt: { default: undefined },
    isLoading: { type: Boolean, default: false },
    filters: null
  },
  emits: ["on-filter-change"],
  setup(__props: any, { emit: emits }: { emit: ((
  event: 'on-filter-change',
  filterType: DerivativesFiltersTypes,
  filter?: DerivativesFiltersTypeValues | DerivativesFiltersDateValues
) => void), expose: any, slots: any, attrs: any }) {

const props = __props as { updatedAt: string, isLoading: boolean, filters: IDerivativesFilters };




const typeOptions = computed(() =>
  props.filters[DerivativesFiltersTypes.Type].available.map(formatFilterOption)
);

const hasTypeOptions = computed(() => typeOptions.value.length > 0);

const formatFilterOption = (option: StringFormatted): IFilterOption => ({
  value: option.value,
  label: option.formatted
});

const handleEmitOnFilterChange = (
  filterKey: DerivativesFiltersTypes,
  filterValue?: DerivativesFiltersTypeValues | DerivativesFiltersDateValues
) => {
  emits('on-filter-change', filterKey, filterValue);
};

return { __sfc: true,props, emits, typeOptions, hasTypeOptions, formatFilterOption, handleEmitOnFilterChange, Heading, FilterSelect, HeaderFilterLoader, HeaderSubtitleLoader, DerivativesFiltersTypes }
}

})